<template>
  <div id="employee-detail">
    <CRow>
      <CCol :md="{ size: 8, offset: 2 }" class="employees-form">
        <div class="text-center">
          <h4 class="title-header">
            {{ $t("label.label_overtime_infomation") }}
          </h4>
          <div class="note-ot">
            <label>{{ $t("commons.note") }}</label>
            <p class="note">
              {{ $t("commons.note_time_ot_lunch", {
                morning_shift_end: overTimeRequest.work_shift.morning_shift_end.slice(0, 5),
                afternoon_shift_start: overTimeRequest.work_shift.afternoon_shift_start.slice(0, 5),
                lunch_break_time: this.hoursBetween(overTimeRequest.work_shift.morning_shift_end, overTimeRequest.work_shift.afternoon_shift_start)
              }) }}
            </p>
            <p class="note">
              {{ $t("commons.note_time_ot_night", {
                afternoon_shift_end: overTimeRequest.work_shift.afternoon_shift_end.slice(0, 5), 
                evening_shift_start: this.addMinutes(overTimeRequest.work_shift.afternoon_shift_end, 30).slice(0, 5)
              }) }}
            </p>
          </div>
        </div>
        <div class="text-content">
          <label>{{ $t("employee.label_employee_code") }}</label>
          <div class="show-text">{{ overTimeRequest.employee_id }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_name") }}</label>
          <div class="show-text">
            {{ overTimeRequest.employee ? overTimeRequest.employee.name : "" }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_position") }}</label>
          <div class="show-text">
            {{
              overTimeRequest.employee
                ? objectNotNull(overTimeRequest.employee.position)
                  ? overTimeRequest.employee.position.name
                  : ""
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_division") }}</label>
          <div class="show-text">
            {{
              overTimeRequest.employee
                ? objectNotNull(overTimeRequest.employee.department)
                  ? overTimeRequest.employee.department.name
                  : ""
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_project_name") }}</label>
          <div class="show-text">
            {{ overTimeRequest.project ? overTimeRequest.project.name : "" }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_over_time_date") }}</label>
          <div class="show-text">{{ overTimeRequest.date | formatDate }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_date_start") }}</label>
          <div class="show-text">{{ overTimeRequest.start_time }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_date_end") }}</label>
          <div class="show-text">{{ overTimeRequest.end_time }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_total_number_hour") }}</label>
          <div class="show-text">{{ overTimeRequest.duration }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_reason") }}</label>
          <div class="show-text">{{ overTimeRequest.reason }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_status") }}</label>
          <div class="show-text">
            {{
              $t(
                `commons.label_status_overtime_request_${overTimeRequest.status}`
              )
            }}
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="8" sm="12" class="employees-form approval-ot">
        <div class="text-label">
          <div class="text-center">
            <h4 class="title-header">
              {{ $t("overtime.information_approval_ot") }}
            </h4>
          </div>
        </div>
        <div class="text-label-content">
          <div class="table-responsive table-employee-note">
            <table class="table">
              <thead>
                <tr>
                  <th class="index">#</th>
                  <th class="text-center create-by">
                    {{ $t("overtime.employee_approval") }}
                  </th>
                  <th class="text-center create-at">
                    {{ $t("overtime.employee_approval_status") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_note") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_time") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in listEmployeeIdApproval"
                  :key="index"
                >
                  <th scope="row index">{{ index + 1 }}</th>
                  <td>{{ item.employees[0].name }}</td>
                  <td class="text-center create-at">
                    {{ $t(`overtime.employee_approval_${item.status}`) }}
                  </td>
                  <td class="text-center comment">{{ item.comment }}</td>
                  <td class="text-center">
                    {{ formatDateOverTime(item.updated_at) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Detail",
  metaInfo() {
    return {
      title: this.$t("page_title.page_overtime_request_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      employeeIdApproval1: "",
      employeeIdApproval2: "",
      listEmployeeIdApproval: []
    };
  },

  async created() {
    await this.showOverTimeRequest();
    for (let key in this.overTimeRequest.over_time_request_approves) {
      this.listEmployeeIdApproval.push(
        this.overTimeRequest.over_time_request_approves[key]
      );
    }
  },

  computed: {
    ...mapGetters({
      overTimeRequest: "overtime-request/overTimeRequest"
    })
  },

  methods: {
    ...mapActions("overtime-request", ["detailOverTimeRequest"]),

    async showOverTimeRequest() {
      let overTimeRequestId = this.$route.params.id;
      await this.detailOverTimeRequest(overTimeRequestId);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },

    formatDateOverTime(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    },

    addMinutes(time, minutes) {
      const [h, m, s = 0] = time.split(':').map(Number)

      const date = new Date(0, 0, 0, h, m, s)
      date.setMinutes(date.getMinutes() + minutes)

      return date.toTimeString().slice(0, 8)
    },

    hoursBetween(start, end) {
      const [sh, sm, ss = 0] = start.split(':').map(Number)
      const [eh, em, es = 0] = end.split(':').map(Number)

      const startMinutes = sh * 60 + sm + ss / 60
      const endMinutes   = eh * 60 + em + es / 60

      return (endMinutes - startMinutes) / 60
    }
  }
};
</script>

<style lang="scss" scoped>
#employee-detail {
  padding: 20px 100px;

  .note-ot {
    text-align: left;
    p.note {
      font-weight: 700;
      color: #ff1a1a;
    }

    label {
      font-weight: 600;
    }
    margin: 20px 0px;
  }

  .title-header {
    border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }

  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;

    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 30px;

      .icon-text-label {
        margin-left: 8px;
      }
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .image {
        width: 70%;
      }

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .text-area {
      height: 60px;
    }

    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }

  #toggle-btn {
    height: 37px;
  }

  .employees-form.approval-ot {
    margin: auto;

    .table-employee-note {
      background-color: white;
      margin-top: 20px;

      th {
        font-size: 15px;
      }

      td {
        color: #3c4b64;
      }

      td.comment {
        max-width: 300px;
        word-wrap: break-word;
      }
    }
  }
}
@media only screen and (max-device-width: 767px) {
  #employee-detail,
  #employee-detail .employees-form {
    padding: 0.3rem;
    .text-content {
      display: block;
      label {
        width: 100%;
      }
      .show-text {
        width: 100%;
        border-radius: 3px;
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #employee-detail {
    padding: 20px 0;
    .employees-form {
      padding: 0;
    }
  }
}
</style>
